module.exports = __webpack_public_path__ + "static/media/img013.0f859fb8.jpg";